import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { Input, Modal, Switch } from "antd";
import {
	btnStyle,
	hideScrollbar,
	inputStyle,
} from "../../lib/styles/styleLibrary";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Loading } from "..";
import { useMutation } from "react-query";
import Auth from "../../lib/middleware/auth";
import { useMediaQuery } from "react-responsive";
import {
	addWeddingPartner,
	addWeddingPlanner,
} from "../../redux/actions/wallet";
import errorHandler from "../../redux/actions/errorHandler";

const Wrapper = styled.div`
	${tw`w-full md:w-9/12 overflow-y-scroll`}
	height: calc(100vh - 15rem);

	@media (max-width: 1023px) {
		width: 100% !important;
		height: calc(100vh - 12rem);
	}
	.active {
		${tw`bg-appPink`}
	}

	.inactive {
		${tw`bg-appTextDark`}
	}

	.label {
		${tw`text-appTextDark opacity-50 font-semibold text-sm md:text-base`}
	}
`;

const PermissionSetting = (props) => {
	const isMobile = useMediaQuery({ maxWidth: 767 });
	const coupleData = Auth.getCouple();
	const [addPlanner, setAddPlanner] = useState(false);
	const [addPartner, setAddPartner] = useState(false);
	const [notifyChecked, setNotifyChecked] = useState(true);
	const [reminderChecked, setReminderChecked] = useState(false);
	const [plannerCode, setPlannerCode] = useState(coupleData?.planner_code);
	const [partnerCode, setPartnerCode] = useState(
		coupleData?.bride_code || coupleData?.groom_code
	);


	// console.log(weddingData, coupleData);
	const { mutateAsync: handleAddPartner, isLoading: addLoading } =
		useMutation(addWeddingPartner);
	const handleAdd = async () => {
		const data = {
			partnerCode,
		};
		try {
			const res = await handleAddPartner(data);
			console.log(res);
			const { hasError, errors } = res.data;
			if (hasError) {
				return errorHandler(errors);
			}

			Toast.fire({
				icon: "success",
				title: `${res.data.message}\nPartner Invited...`,
			});
			// console.log(res.data.data.wedding);
			Auth.setCouple(res.data.data.wedding);
			setTimeout(() => {
				setAddPartner(false);
			}, 500);
		} catch (err) {
			console.log("the error", err);
		}
	};

	const { mutateAsync: handleAddPlanner, isLoading: plannerLoading } =
		useMutation(addWeddingPlanner);
	const handlePartner = async () => {
		const data = {
			plannerCode,
		};
		try {
			const res = await handleAddPlanner(data);
			console.log(res);
			const { hasError, errors } = res.data;
			if (hasError) {
				return errorHandler(errors);
			}

			Toast.fire({
				icon: "success",
				title: `${res.data.message}\nPlanner Invited...`,
			});

			Auth.setCouple(res.data.data.wedding);
			setTimeout(() => {
				setAddPlanner(false);
			}, 500);
		} catch (err) {
			console.log("the error", err);
		}
	};

	return (
		<Wrapper css={hideScrollbar}>
			<div tw="mt-2">
				<label htmlFor="name" className="label">
					Notifications
				</label>

				<div
					css={inputStyle}
					tw="mt-4 flex flex-row items-center justify-between px-5!">
					<span tw="font-semibold text-sm">Allow notifications</span>
					<Switch
						checked={notifyChecked}
						tw="pr-2"
						onChange={() => setNotifyChecked(!notifyChecked)}
						className={notifyChecked ? "active" : "inactive"}
						size="default"
					/>
				</div>
				<div
					css={inputStyle}
					tw="flex flex-row items-center justify-between px-5!">
					<span tw="font-semibold text-sm">
						Allow calendar reminder
					</span>
					<Switch
						checked={reminderChecked}
						tw="pr-2"
						onChange={() => setReminderChecked(!reminderChecked)}
						className={reminderChecked ? "active" : "inactive"}
						size="default"
					/>
				</div>
			</div>
			<div tw="mt-10">
				<label htmlFor="name" className="label">
					Administrator
				</label>

				<div
					onClick={() =>
						isEmpty(coupleData?.bride_code) ||
						isEmpty(coupleData?.groom_code)
							? setAddPartner(true)
							: Toast.fire({
									icon: "error",
									title: "Partner exist as collaborator",
							  })
					}
					css={inputStyle}
					tw="mt-4 flex flex-row items-center justify-between px-5! hover:cursor-pointer">
					<span tw="font-semibold text-sm">
						Add partner (bride or groom)
					</span>
					<div tw="h-8 w-8 px-2 py-2 bg-gray-100 rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800 shadow) flex flex-col items-center justify-center">
						<ArrowRightOutlined tw="hover:(text-purple-800 transform scale-125)" />
					</div>
				</div>

				<div
					onClick={() => setAddPlanner(true)}
					css={inputStyle}
					tw="flex flex-row items-center justify-between px-5!  hover:cursor-pointer">
					<span tw="font-semibold text-sm">Add event planner</span>
					<div tw="h-8 w-8 px-2 py-2 bg-gray-100 rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800 shadow) flex flex-col items-center justify-center">
						<ArrowRightOutlined tw="hover:(text-purple-800 transform scale-125)" />
					</div>
				</div>
			</div>
			<Modal
				footer=""
				visible={addPlanner}
				width={isMobile ? "100%" : "50%"}
				centered
				onCancel={() => setAddPlanner(false)}
				maskClosable={false}>
				<div>
					<div tw="h-8 w-8 px-2 py-2 bg-gray-100 rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800 shadow) flex flex-col items-center justify-center">
						<ArrowLeftOutlined
							onClick={() => setAddPlanner(false)}
							tw="hover:(text-purple-800 transform scale-125)"
						/>
					</div>
					<h3 tw="mt-2 font-semibold text-sm md:text-xl">
						Invite your planner
					</h3>
					<div>
						<div tw="text-appTextFaded text-sm">
							Invite your planner as you continue to prepare for
							your big day.
						</div>
						<div tw="text-appTextFaded mt-1 text-sm!">
							<span>Your planner will be able to;</span>
							<span tw="flex flex-col gap-1">
								<span>Add guest list</span>
								<span>Share invitation</span>
								<span>Make plans</span>
							</span>
						</div>
					</div>

					<Input
						css={inputStyle}
						placeholder={"05plannerXYZ"}
						value={plannerCode}
						onChange={(e) => {
							setPlannerCode(e.target.value);
						}}
						tw="mt-8 text-center flex items-center py-7! text-2xl! font-bold justify-center"
					/>

					<div tw="mt-8 mb-8">
						<button css={btnStyle} onClick={handlePartner}>
							{plannerLoading ? (
								<Loading />
							) : (
								"Share invitation code"
							)}
						</button>
					</div>
				</div>
			</Modal>

			<Modal
				footer=""
				visible={addPartner}
				width={isMobile ? "100%" : "50%"}
				centered
				onCancel={() => setAddPartner(false)}
				maskClosable={false}>
				<div>
					<div tw="h-8 w-8 px-2 py-2 bg-gray-100 rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800 shadow) flex flex-col items-center justify-center">
						<ArrowLeftOutlined
							onClick={() => setAddPartner(false)}
							tw="hover:(text-purple-800 transform scale-125)"
						/>
					</div>
					<h3 tw="mt-2 font-semibold text-sm md:text-xl">
						Collaborate with your partner
					</h3>
					<div>
						<div tw="text-appTextFaded text-sm">
							You don’t have to do this alone, start off your
							beautiful love journey by collaborating with your
							partner.
						</div>
						<div tw="text-appTextFaded mt-1 text-sm!">
							<span>
								Your partner will be able to do everything you
								can do with the Weddingstory app.
							</span>{" "}
							<span tw="text-appPink">
								{" "}
								This code can only be used once
							</span>
						</div>
					</div>

					<Input
						css={inputStyle}
						placeholder={
							coupleData?.bride_code || coupleData?.groom_code
						}
						value={partnerCode}
						onChange={(e) => {
							setPartnerCode(e.target.value);
						}}
						tw="mt-10 text-center flex items-center py-7! text-2xl! font-bold justify-center"
					/>

					<div tw="mt-8 mb-8">
						<button css={btnStyle} onClick={handleAdd}>
							{addLoading ? <Loading /> : "Share invitation code"}
						</button>
					</div>
				</div>
			</Modal>
			{/* {editLoading && <PageLoading />} */}
		</Wrapper>
	);
};

export default PermissionSetting;
